var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgConnect = function SvgConnect(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 249,
    height: 294,
    fill: "none",
    viewBox: "0 0 249 294"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#1a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M198.421 257.598c-20.785 14.578-45.93 24.014-73.022 24.014s-52.97-9.719-73.937-24.646c-6.108-4.36-9.32-11.716-8.304-19.138l2.063-15.043c22.516 17.606 50.54 27.541 79.746 27.541s56.23-9.569 78.497-26.576l2.928 13.097c1.764 7.904-1.348 16.125-7.987 20.768z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 14,
    d: "M156.419 16.998c-11.383-3.445-23.515-5.059-36.062-4.526C60.415 15.035 13.903 65.707 16.465 125.633c.999 23.314 9.286 44.598 22.533 61.772 20.851 26.942 54.017 43.684 90.628 42.119 36.861-1.581 68.646-21.334 87.034-50.273 11.549-18.106 17.84-39.823 16.841-62.904a108.2 108.2 0 0 0-5.375-29.455"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "m211.368 52.328 22.682-6.357c1.614-.45 1.614-2.73 0-3.179l-22.649-6.457c-.549-.15-.982-.599-1.148-1.148l-6.357-22.682c-.449-1.614-2.729-1.614-3.178 0l-6.457 22.649c-.15.55-.599.982-1.149 1.148L170.43 42.66c-1.614.45-1.614 2.73 0 3.179l22.649 6.456c.549.15.982.6 1.148 1.149l6.357 22.682c.45 1.614 2.73 1.614 3.179 0l6.457-22.649c.15-.55.599-.982 1.148-1.148M158.205 89.986l15.526-4.344c1.099-.316 1.099-1.864 0-2.18l-15.509-4.426c-.383-.1-.666-.4-.782-.783l-4.344-15.526c-.316-1.098-1.864-1.098-2.18 0l-4.426 15.51c-.1.383-.4.682-.783.782l-15.526 4.343c-1.098.317-1.098 1.864 0 2.18l15.51 4.427c.383.1.665.4.782.782l4.343 15.526c.317 1.099 1.864 1.099 2.18 0l4.427-15.51c.1-.382.399-.682.782-.781M194.989 129.794l12.281-3.444c.866-.25.866-1.482 0-1.731l-12.264-3.495a.88.88 0 0 1-.616-.616l-3.445-12.281c-.249-.865-1.481-.865-1.73 0l-3.495 12.265a.89.89 0 0 1-.616.616l-12.281 3.444c-.866.25-.866 1.481 0 1.731l12.264 3.495c.3.083.533.316.616.615l3.445 12.282c.25.865 1.481.865 1.731 0l3.494-12.265a.89.89 0 0 1 .616-.616"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 14,
    d: "M52.63 130.954c-3.029-28.939 10.534-55.782 33-71.092M109.942 48.946a78 78 0 0 1 10.717-1.897"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "1a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h249v294H0z"
  })))));
};
export default SvgConnect;